import React from "react";
import "../assets/css/spinner.css";
export default function LoadingSpinner() {
  return React.createElement(
    "div",
    { className: "spinner-container" },
    React.createElement("div", { className: "loading-spinner" })
  );
}
